export enum ViewModeEnum {
    Add,
    Edit,
}


// WEBPACK FOOTER //
// ./src/app/_enums/view-mode.enum.ts